import Status from '@ingka/status';
import type { LotteryStatus as LotteryStatusType } from '@lotta/shared/types-lottery-schemas';
import { useTranslation } from 'react-i18next';
import { startDateStringToJS } from '@lotta/shared/util-dates';

export type LotteryStatusProps = {
  lotteryStatus: LotteryStatusType;
  nbrDrawsMade: number;
  startDate: string;
  timeZone: string;
  totalDraws: number;
};

export const LotteryStatus = ({
  lotteryStatus,
  nbrDrawsMade,
  totalDraws,
  startDate,
  timeZone,
}: LotteryStatusProps) => {
  const { t } = useTranslation();

  switch (lotteryStatus) {
    case 'PENDING':
      if (new Date() < startDateStringToJS(startDate, timeZone)) {
        return <Status statusColor="orange" small label={`${t('general-pending')}`} />;
      } else {
        return <Status statusColor="green" small label={`${t('home-lottery-status-ongoing')}`} />;
      }

    case 'ONGOING':
      return <Status statusColor="green" small label={`${t('home-lottery-status-ongoing')}`} />;
    case 'COMPLETED':
      return (
        <Status
          statusColor="grey"
          small
          label={
            nbrDrawsMade === totalDraws
              ? `${t('home-lottery-status-completed')}`
              : `${t('home-lottery-status-ongoing')}`
          }
        />
      );
    case 'STOPPED':
      return <Status statusColor="grey" small label={`${t('home-lottery-status-stopped')}`} />;

    default:
      return <Status statusColor="red" small label={`${t('general-unknown')}`} />;
  }
};
